<template>
  <div id="app" class="centre">
    <v-app>
      <v-card
        flat
        tile
      >
        <v-app-bar :color="globalColorA" dense fixed >
          <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

          <v-toolbar-title class="pl-1">
            <v-img width="35" :src="require('./assets/business logo.png')"></v-img>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn class="ma-2" outlined @click="routePage('/')">
            <v-icon >mdi-home-outline</v-icon>
            <span :class="'font-weight-medium text-center subtitle-1 pt-1 customGrey--text'">{{globalLanguage.topBarInfo}}</span>
          </v-btn>

          <v-btn class="ma-2" outlined @click="routePage('Portfolio')">
            <v-icon >mdi-briefcase-outline</v-icon>
            <span :class="'font-weight-medium text-center subtitle-1 pt-1 customGrey--text'">{{globalLanguage.topBarPortfolio}}</span>
          </v-btn>

          <!-- <v-btn class="ma-2" outlined @click="routePage('Pricing')">
            {{globalLanguage.topBarPricing}}
            <v-icon>mdi-file-outline</v-icon>
          </v-btn> -->
        </v-app-bar>
      </v-card>

      <v-container class="pt-15" >
        <v-row no-gutters>
          <v-col  cols="auto" sm="1" lg="2"></v-col>
          <v-col  cols="auto" sm="10" lg="8">
            <!-- <img  src="./assets/logo.png"> -->
            <v-card elevation="8">
              <router-view 
                :globalColorA="globalColorA"
                :globalColorB="globalColorB"
                :globalColorC="globalColorC"
                :globalLanguage="globalLanguage"
              />
            </v-card>
          </v-col>
          <v-col  cols="auto" sm="1" lg="2"></v-col>
        </v-row>
      </v-container>

       <v-snackbar
          v-model="promptChangeLanguage"
          centered
        >
          <p :class="`font-weight-light headline white--text`">Tukar ke Bahasa Melayu?</p>
          <v-btn class="ma-2" @click="changeLang('bm') ; promptChangeLanguage = !promptChangeLanguage">
            <span :class="`font-weight-light title salmonOrange--text`">Ya!, Saya mahu</span>
          </v-btn>
          <v-btn class="ma-2" @click="promptChangeLanguage = !promptChangeLanguage">
            <span :class="`font-weight-light title salmonOrange--text`">Nah!, I'm good</span>
          </v-btn>
      </v-snackbar>
     
      <v-footer
        dark
        padless
      >
        <v-card
          class="flex"
          flat
          tile
          :color="globalColorA"
        >
          
          <!-- <v-card-text class="py-2 black--text text-center">
            <p class="title font-weight-medium">{{globalLanguage.BottomBarContactInfo}}</p>
            <p >{{globalLanguage.BottomBarContactNumber}} : 0137594647</p>
            <p >{{globalLanguage.BottomBarContactEmail}} : izzul950107@gmail.com</p>
          </v-card-text> -->

            <v-divider></v-divider>
          <v-card-text class="py-2 black--text text-right">
            <p style="cursor:pointer" @click="changeLang('eng')">View Page in English</p>
            <p style="cursor:pointer" @click="changeLang('bm')">Lihat Halaman dalam Bahasa Malaysia</p>
          </v-card-text>
        </v-card>
      </v-footer>
    </v-app>
  </div>


</template>

<script>
import GLOBALBM from "./languageJSON/bm.json"
import GLOBALENG from "./languageJSON/eng.json"

export default {
  name: 'App',
  data () {
    return {
      promptChangeLanguage : true,

      globalLanguage : '',
      globalColorA : '#aed6dc',
      globalColorB : '#ff9a8d',
      globalColorC : '#4a536b',
    }
  },

  mounted()
  {
    this.globalLanguage = GLOBALENG
  },

  methods : {
    changeLang(selected)
    {
      if(selected == "bm")
      {
        this.globalLanguage = GLOBALBM
      }
      if(selected == "eng")
      {
       this.globalLanguage = GLOBALENG
      }
    },

    routePage(link)
    {
      this.$router.push(link) 
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/App.vue